export default __webpack_public_path__ + "static/media/flag-bulgaria.bfd91426.svg";